const DEFAULT_LOCALE = 'en-EN';

const capitalizeFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1);
const secondsToHour = (seconds) => (seconds / 0xE10).toFixed(2).toString();
const getDayName = (date) => capitalizeFirstLetter(date.toLocaleDateString(DEFAULT_LOCALE, { weekday: 'long' }));
const calculatePercentaje = (hours, totalHours) => ((hours * 100) / totalHours)?.toFixed(2);

export default {
    calculatePercentaje,
    getDayName,
    secondsToHour,
}
